import PropTypes from "prop-types";
import useModal from "../../../../core/hooks/use-modal";
import { getDayOfTheWeek } from "../../../../core/helpers/date-helper";
import CeldaCuadroTurno from "./CeldaCuadroTurnos/celda-cuadro-turnos";
import { useContext } from "react";
import CuadroTurnosContext from "../../store/cuadro-turnos-context";
import { useState } from "react";
import { useEffect } from "react";
import { obtenerConfiguracionesNomina } from "../../../NominaConfiguraciones/services/configuraciones-service";
import { toast } from "../../../../core/helpers/message-helper";
import BotonAccionesCuadroTurnos from "./BotonesAccionesCuadroTurnos/boton-acciones-cuadro-turnos";

const CuerpoTablaCuadrosTurnos = ({
    onEmpleadoAccion,
    dataCuadroTurnos = {},
}) => {
    const { filtros } = useContext(CuadroTurnosContext);
    const { fechasCuadroTurnos, cuadroTurnos } = dataCuadroTurnos;
    const [configuracionesNomina, setConfiguracionesNomina] = useState({});

    const modalEditarTurnos = useModal({
        data: {
            turno: {},
            fecha: null,
            celdaId: null,
            personaId: null,
            totalHorasSemanaId: null,
            onTurnoModificado: () => {},
            totalHorasAcumuladasId: null,
        },
    });

    useEffect(async () => {
        const resp = await obtenerConfiguracionesNomina();
        if (!resp.status) return toast.error(resp.message);
        setConfiguracionesNomina(resp.data);
    }, []);

    const getEstiloCelda = (fecha = null, color = "") => {
        const estilosAdicionales = {};

        if (fecha != null) {
            const dayOfTheWeek = getDayOfTheWeek(fecha);
            const esFestivo = dataCuadroTurnos.festivos[fecha] != null;

            estilosAdicionales.backgroundColor = esFestivo
                ? "red"
                : dayOfTheWeek == "DOM"
                ? "yellow"
                : color;
        }

        return {
            padding: "1px",
            ...estilosAdicionales,
        };
    };

    const estiloCeldaComun = getEstiloCelda();
    let totalCeldasPintadas = 0;

    // Crear fila de turnos para cada empleado
    const empleados = cuadroTurnos.map((sedeSubArea) => {
        const maxHorasTrabajadasAlMes =
            configuracionesNomina.maximo_horas_trabajadas_al_mes?.valor;

        const maxHorasTrabajadasALaSemana =
            configuracionesNomina.maximo_horas_trabajadas_a_la_semana?.valor;

        const sumatoriaTurnos = {};

        const filasEmpleados = sedeSubArea.personas.map((persona) => {
            const fechas = [];
            let conteoCeldasTotalHoras = 0;
            let totalHorasSemana = 0;
            let totalHorasAcumuladas = 0;
            let personaTieneAlertas = false;
            // Recorrer el rango de fecha en el cual existen turnos, esto con el fin de
            // pintar la misma cantidad de celdas para cada empleado, si el empleado no tiene
            // turnos en una fecha determinada, se pintará la celda de esa fecha pero sin el
            // "select" de turnos
            for (const mes in fechasCuadroTurnos) {
                const totalHorasAcumuladasId = `total-horas-acumuladas-${persona.documento}-${sedeSubArea.sub_area_nombre}-${mes}`;

                fechasCuadroTurnos[mes].dias.forEach(({ fecha }, index) => {
                    const totalHorasSemanaId = `total-horas-${persona.documento}-${conteoCeldasTotalHoras}`;

                    const turno = persona.turnos[fecha] ?? {};
                    const horasExtras = Array.isArray(persona.horas_extras)
                        ? {}
                        : persona.horas_extras;

                    const idCeldaTurno = `fecha-${fecha}-${persona.documento}-${
                        index + 1
                    }-${++totalCeldasPintadas}`;

                    fechas.push(
                        <CeldaCuadroTurno
                            turno={turno}
                            fecha={fecha}
                            key={idCeldaTurno}
                            personaId={persona.id}
                            idCeldaTurno={idCeldaTurno}
                            getEstiloCelda={getEstiloCelda}
                            subAreaId={sedeSubArea.sub_area_id}
                            modalEditarTurnos={modalEditarTurnos}
                            totalHorasSemanaId={totalHorasSemanaId}
                            sedeAreaLider={filtros.sedeAreaLider}
                            totalHorasAcumuladasId={totalHorasAcumuladasId}
                        />
                    );

                    const textoDiaDeLaSemana = getDayOfTheWeek(fecha);

                    let horasTurnosDelDia = 0;

                    if (turno.libre != 1) horasTurnosDelDia += turno.horas;
                    if (!sumatoriaTurnos[fecha]) {
                        sumatoriaTurnos[fecha] = { };
                    }

                    if(!sumatoriaTurnos[fecha][turno.sigla]) {
                        sumatoriaTurnos[fecha][turno.sigla] = 0;
                    }

                    sumatoriaTurnos[fecha][turno.sigla]++;

                    const horasExtrasDelDia = horasExtras[fecha]?.total ?? 0;
                    totalHorasSemana += horasTurnosDelDia + horasExtrasDelDia;
                    totalHorasSemana = parseFloat(totalHorasSemana.toFixed(1)); // Convierte a número con 1 decimal

                    if (
                        textoDiaDeLaSemana === "DOM" ||
                        fechasCuadroTurnos[mes].dias.length - 1 === index
                    ) {
                        fechas.push(
                            <td
                                key={totalHorasSemanaId}
                                id={totalHorasSemanaId}
                                className="celda-acumulado-horas"
                                title={
                                    totalHorasSemana >
                                    maxHorasTrabajadasALaSemana
                                        ? `Se han superado las ${maxHorasTrabajadasALaSemana} horas de trabajo semanales`
                                        : ""
                                }
                                style={{
                                    ...estiloCeldaComun,
                                    color:
                                        totalHorasSemana >
                                        maxHorasTrabajadasALaSemana
                                            ? "red"
                                            : "",
                                    fontWeight:
                                        totalHorasSemana >
                                        maxHorasTrabajadasALaSemana
                                            ? "bold"
                                            : "",
                                }}
                            >
                                {totalHorasSemana}
                            </td>
                        );

                        if (totalHorasSemana > maxHorasTrabajadasALaSemana)
                            personaTieneAlertas = true;
                        totalHorasAcumuladas += totalHorasSemana;
                        totalHorasSemana = 0;
                        conteoCeldasTotalHoras++;
                        totalCeldasPintadas++;
                    }

                    if (fechasCuadroTurnos[mes].dias.length - 1 === index) {
                        fechas.push(
                            <td
                                key={totalHorasAcumuladasId}
                                id={totalHorasAcumuladasId}
                                className="celda-acumulado-horas"
                                title={
                                    totalHorasAcumuladas >
                                    maxHorasTrabajadasAlMes
                                        ? `Se han superado las ${maxHorasTrabajadasAlMes} horas de trabajo semanales`
                                        : ""
                                }
                                style={{
                                    ...estiloCeldaComun,
                                    color:
                                        totalHorasAcumuladas >
                                        maxHorasTrabajadasAlMes
                                            ? "red"
                                            : "",
                                    fontWeight:
                                        totalHorasAcumuladas >
                                        maxHorasTrabajadasAlMes
                                            ? "bold"
                                            : "",
                                }}
                            >
                                {parseFloat(totalHorasAcumuladas.toFixed(1))}
                            </td>
                        );

                        if (totalHorasAcumuladas > maxHorasTrabajadasAlMes) {
                            personaTieneAlertas = true;
                        }

                        totalHorasAcumuladas = 0;
                        conteoCeldasTotalHoras++;
                        totalCeldasPintadas++;
                    }
                });
            }

            return (
                <tr
                    className="text-center"
                    id={persona.documento}
                    key={persona.documento}
                >
                    <td style={estiloCeldaComun}>
                        <BotonAccionesCuadroTurnos
                            onEmpleadoAccion={onEmpleadoAccion}
                            personaId={persona.id}
                        />
                    </td>
                    <td
                        style={{
                            ...estiloCeldaComun,
                            position: "sticky",
                            left: 0,
                            backgroundColor: "white",
                        }}
                    >
                        <span
                            title={
                                personaTieneAlertas
                                    ? "Esta persona tiene alertas"
                                    : ""
                            }
                            style={{
                                fontSize: "9px",
                                color: personaTieneAlertas ? "red" : "",
                                fontWeight: personaTieneAlertas ? "bold" : "",
                            }}
                        >
                            {persona.nombres} ({persona.documento})
                        </span>
                    </td>
                    {fechas}
                </tr>
            );
        });

        const turnosSiglasSuma = ["N", "C"];
        let filaSumatoriaDias = [];
        for (const mes in fechasCuadroTurnos) {
            if (Object.hasOwnProperty.call(fechasCuadroTurnos, mes)) {
                fechasCuadroTurnos[mes].dias.forEach((dia, index) => {
                    const textoDiaDeLaSemana = getDayOfTheWeek(dia.fecha);
                    const fila = (
                        <td
                            key={`${mes}${dia.fecha}${sedeSubArea.sub_area_id}fila${index}`}
                            className="text-white"
                            style={{ textAlign: "center", padding: "1px" }}
                        >
                            {turnosSiglasSuma.map((sigla) => {
                                return (
                                    <>
                                        <span
                                            className="celda-acumulado-turnos"
                                            key={`${sedeSubArea.sub_area_id}${dia.fecha}-sumatoriaDias`}
                                            id={`${sedeSubArea.sub_area_id}${dia.fecha}-sumatoriaDias`}
                                            style={{display: 'inline-block'}}
                                        >
                                            {sigla}:
                                            <span
                                                id={`cantidad-turnos-${sigla}-${sedeSubArea.sub_area_id}-${dia.fecha}`}
                                            >
                                                {sumatoriaTurnos[dia.fecha]?.[
                                                    sigla
                                                ] ?? 0}
                                            </span>
                                            <br />
                                        </span>
                                        <br />
                                    </>
                                );
                            })}
                        </td>
                    );
                    filaSumatoriaDias.push(fila);
                    if (textoDiaDeLaSemana === "DOM") {
                        filaSumatoriaDias.push(
                            <td
                                key={`${mes}${dia.fecha}${sedeSubArea.sub_area_id}${index}`}
                                className="celda-acumulado-horas"
                            ></td>
                        );
                    }

                    if (
                        fechasCuadroTurnos[mes].dias.length - 1 ===
                        index
                    ) {
                        if(textoDiaDeLaSemana != "DOM"){
                            filaSumatoriaDias.push(
                                <td
                                    key={`${mes}${dia.fecha}${sedeSubArea.sub_area_id}${index}totalSemana`}
                                    className="celda-acumulado-horas"
                                ></td>
                            );
                        }

                        filaSumatoriaDias.push(
                            <td
                                style={{ maxWidth: "20px" }}
                                className="celda-acumulado-horas"
                                key={`${mes}${dia.fecha}${sedeSubArea.sub_area_id}${index}totalMes`}
                            ></td>
                        );
                    }
                });
            }
        }

        return (
            <>
                <tr
                    className="bg-secondary"
                    key={`${sedeSubArea.sede_id}-${sedeSubArea.sub_area_id}`}
                    id={`${sedeSubArea.sede_id}-${sedeSubArea.sub_area_id}`}
                >
                    <td
                        colSpan={2}
                        className="text-white"
                        style={{ padding: "6px" }}
                    >
                        {sedeSubArea.sede_nombre} -{" "}
                        {sedeSubArea.sub_area_nombre}
                    </td>
                    {filaSumatoriaDias}
                </tr>
                {filasEmpleados}
            </>
        );
    });

    return (
        <>
            <tbody>
                {empleados.length > 0 ? (
                    empleados
                ) : (
                    <tr>
                        <td colSpan={10}>No hay datos para mostrar</td>
                    </tr>
                )}
            </tbody>
        </>
    );
};

CuerpoTablaCuadrosTurnos.propTypes = {
    onEmpleadoAccion: PropTypes.func,
    dataCuadroTurnos: PropTypes.object,
};

export default CuerpoTablaCuadrosTurnos;
